import { Link, Navigate } from "react-router-dom";
import { selectIsLoggedIn, selectUserRole } from "../../../src/redux/app";

import { CAREERS_URL } from "./landing_pages/navigation/config/navConfig";
import { getPortalLandingPath } from "./util/portalRoutes";
import { useAppSelector } from "../../../src/redux/hooks";

export default function NewHomePage() {
  const cardStyles = `tw-p-[13px] tw-bg-white tw-rounded-[4px] tw-shadow-sm hover:tw-shadow-lg tw-m-[10px]
    tw-w-[280px] 1040:tw-w-full tw-flex tw-flex-row tw-flex-wrap hover:tw-no-underline focus:tw-no-underline tw-cursor-pointer tw-transition-all tw-ease`;

  const isLoggedIn = useAppSelector(selectIsLoggedIn);
  const role = useAppSelector(selectUserRole);

  if (isLoggedIn && role.length > 0) {
    return <Navigate to={getPortalLandingPath(role)} replace />;
  }

  return (
    <div className="tw-relative tw-overflow-x-hidden">
      <div className="tw-absolute tw-left-[50vw] tw-top-0 tw-z-0 tw-h-[1280px] tw-w-[1280px] tw-translate-x-[-50%] tw-translate-y-[-60%] tw-rounded-full tw-bg-gray-light-3"></div>
      <div className="tw-relative tw-mx-auto tw-max-w-[1040px] tw-px-[20px]">
        <div className="tw-mb-[50px] tw-mt-[100px] tw-text-center">
          <a
            href={CAREERS_URL}
            className="tw-rounded-full tw-bg-blue-2 tw-p-[13px] tw-px-[15px] tw-text-white tw-shadow-sm hover:tw-bg-blue-0 hover:tw-text-white hover:tw-no-underline focus:tw-text-white focus:tw-no-underline"
          >
            We are hiring!
          </a>
        </div>

        <h1 className="tw-m-auto tw-text-center" data-testid="home-page-header">
          AI-enabled ordering for medical equipment & supplies.
        </h1>

        <h4 className="tw-my-[30px] tw-text-center tw-font-dm-sans tw-text-blue-1">
          Take the pain & confusion out of ordering Durable Medical Equipment
          (DME).
        </h4>

        <div className="tw-flex tw-flex-row tw-flex-wrap tw-justify-center">
          <Link className={cardStyles} to="/password-login">
            <div className="tw-h-[160px] tw-w-[280px] tw-bg-[url('/homepage/img1.png')] tw-bg-contain tw-bg-bottom tw-bg-no-repeat 540:tw-w-full"></div>
            <div className="1040:tw-p-[10px] 1040:tw-px-[15px]">
              <h5 className="tw-mb-[10px] tw-mt-[18px] tw-font-dm-sans tw-uppercase tw-tracking-[0.08em] tw-text-gray-3">
                FOR CLINICAL STAFF
              </h5>
              <h4 className="tw-font-domine tw-text-[19px] tw-tracking-[-0.03em] tw-text-blue-dark-1">
                Are you already working with us?
              </h4>
              <span className="tw-mt-[5px] tw-text-blue-1">
                Account login <i className="fa fa-arrow-right" />
              </span>
            </div>
          </Link>
          <Link className={cardStyles} to="/contact_us">
            <div className="tw-h-[160px] tw-w-[280px] tw-bg-[url('/homepage/img2.png')] tw-bg-contain tw-bg-bottom tw-bg-no-repeat 540:tw-w-full"></div>
            <div className="1040:tw-p-[10px] 1040:tw-px-[15px]">
              <h5 className="tw-mb-[10px] tw-mt-[18px] tw-font-dm-sans tw-uppercase tw-tracking-[0.08em] tw-text-gray-3">
                FOR CLINICAL STAFF
              </h5>
              <h4 className="tw-font-domine tw-text-[19px] tw-tracking-[-0.03em] tw-text-blue-dark-1">
                Are you interested in our service?
              </h4>
              <span className="tw-mt-[5px] tw-text-blue-1">
                Learn how to enroll <i className="fa fa-arrow-right" />
              </span>
            </div>
          </Link>
          <Link className={cardStyles} to="/contact_us">
            <div className="tw-h-[160px] tw-w-[280px] tw-bg-[url('/homepage/img3.png')] tw-bg-contain tw-bg-bottom tw-bg-no-repeat 540:tw-w-full"></div>
            <div className="1040:tw-p-[10px] 1040:tw-px-[15px]">
              <h5 className="tw-mb-[10px] tw-mt-[18px] tw-font-dm-sans tw-uppercase tw-tracking-[0.08em] tw-text-gray-3">
                FOR PATIENTS
              </h5>
              <h4 className="tw-font-domine tw-text-[19px] tw-tracking-[-0.03em] tw-text-blue-dark-1">
                Are you looking for a reliable DME experience?
              </h4>
              <span className="tw-mt-[5px] tw-text-blue-1">
                Contact us <i className="fa fa-arrow-right" />
              </span>
            </div>
          </Link>
        </div>
        <div className="tw-mt-[100px] tw-flex tw-flex-row tw-flex-wrap">
          <div className="tw-w-1/2 tw-p-[13px] 840:tw-w-full">
            <h5 className="tw-mt-[25px] tw-font-dm-sans tw-uppercase tw-tracking-[0.08em] tw-text-blue-1">
              A new experience for in-home care
            </h5>
            <h2 className="tw-text-[28px]">
              Ordering equipment & supplies should be easy
            </h2>
            <div className="tw-my-[35px] tw-text-[16px] tw-text-gray-2">
              <div className="tw-my-[23px]">
                <img
                  src="/homepage/checkmark_image.png"
                  className="tw-mr-[8px] tw-inline-block tw-h-[18px] tw-align-middle"
                />
                <div className="tw-inline-block tw-align-middle">
                  Ordering & tracking software that fits into your workflow
                </div>
              </div>
              <div className="tw-my-[23px]">
                <img
                  src="/homepage/checkmark_image.png"
                  className="tw-mr-[8px] tw-inline-block tw-h-[18px] tw-align-middle"
                />
                <div className="tw-inline-block tw-align-middle">
                  Nearly all insurances accepted
                </div>
              </div>
              <div className="tw-my-[23px]">
                <img
                  src="/homepage/checkmark_image.png"
                  className="tw-mr-[8px] tw-inline-block tw-h-[18px] tw-align-middle"
                />
                <div className="tw-inline-block tw-align-middle">
                  High quality, reliable patient experience
                </div>
              </div>
            </div>
            <Link
              to="/contact_us"
              className="tw-ease tw-rounded-md tw-bg-blue-2 tw-px-[13px] tw-py-[10px] tw-text-white tw-transition-all hover:tw-bg-blue-0 hover:tw-text-white hover:tw-no-underline focus:tw-text-white focus:tw-no-underline"
            >
              Learn more
            </Link>
          </div>
          <div className="tw-w-1/2 tw-p-[5px] 840:tw-hidden">
            <img src="/homepage/img4.png" className="tw-h-[400px]" />
          </div>
        </div>
        <div className="tw-mt-[90px] tw-p-[13px]">
          <h5 className="tw-text-center tw-font-dm-sans tw-uppercase tw-tracking-[0.08em] tw-text-blue-1">
            A dependable, time-saving experience
          </h5>
          <h2 className="tw-my-[25px] tw-text-[28px]">
            We operate as an extension of your clinic and save your nurses their
            most precious resource:{" "}
            <span className="tw-border-1 tw-border-x-0 tw-border-t-0 tw-border-solid tw-border-blue-2 tw-bg-blue-light-1 tw-px-[3px]">
              time.
            </span>
          </h2>
          <div className="tw-my-[20px] tw-flex tw-flex-row tw-flex-wrap tw-justify-between 840:tw-justify-center">
            <div className="tw-max-w-[300px] 840:tw-text-center">
              <img
                src="/software_platform.png"
                className="tw-my-[15px] tw-h-[120px] 840:tw-mx-auto"
              />
              <div>
                <h4 className="tw-text-[20px] tw-font-bold tw-tracking-[-0.03em] tw-text-blue-dark-1">
                  AI Extraction
                </h4>
                <p className="tw-text-[16px] tw-text-gray-2">
                  Verse can automatically extract order information from the
                  medical record with AI.
                </p>
              </div>
            </div>
            <div className="tw-max-w-[300px] 840:tw-text-center">
              <img
                src="/wide_coverage.png"
                className="tw-my-[15px] tw-h-[120px] 840:tw-mx-auto"
              />
              <div>
                <h4 className="tw-text-[20px] tw-font-bold tw-tracking-[-0.03em] tw-text-blue-dark-1">
                  Full Transparency & Visibility
                </h4>
                <p className="tw-text-[16px] tw-text-gray-2">
                  Track every order, down to specific items.
                </p>
              </div>
            </div>
            <div className="tw-max-w-[300px] 840:tw-text-center">
              <img
                src="time_saved.png"
                className="tw-my-[15px] tw-h-[120px] 840:tw-mx-auto"
              />
              <div>
                <h4 className="tw-text-[20px] tw-font-bold tw-tracking-[-0.03em] tw-text-blue-dark-1">
                  10-15 hours saved
                </h4>
                <p className="tw-text-[16px] tw-text-gray-2">
                  For your clinic, every week with our software.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="tw-my-[100px] tw-flex tw-flex-row tw-flex-wrap">
          <div className="tw-w-1/2 tw-p-[13px] 840:tw-w-full">
            <h5 className="tw-mt-[25px] tw-font-dm-sans tw-uppercase tw-tracking-[0.08em] tw-text-blue-1">
              All in one
            </h5>
            <h2 className="tw-text-[28px]">
              Eliminate back and forth over fax & phone with Verse.
            </h2>
            <div className="tw-my-[35px]">
              <div className="tw-my-[23px]">
                <img
                  src="/homepage/checkmark_image.png"
                  className="tw-mr-[8px] tw-inline-block tw-h-[18px] tw-align-middle"
                />
                <div className="tw-inline-block tw-align-middle tw-text-[16px] tw-text-gray-2">
                  Replace fax forms with an online workflow
                </div>
              </div>

              <div className="tw-my-[23px]">
                <img
                  src="/homepage/checkmark_image.png"
                  className="tw-mr-[8px] tw-inline-block tw-h-[18px] tw-align-middle"
                />
                <div className="tw-inline-block tw-align-middle tw-text-[16px] tw-text-gray-2">
                  Verse can extract DME orders directly from patient notes
                </div>
              </div>

              <div className="tw-my-[23px]">
                <img
                  src="/homepage/checkmark_image.png"
                  className="tw-mr-[8px] tw-inline-block tw-h-[18px] tw-align-middle"
                />
                <div className="tw-inline-block tw-align-middle tw-text-[16px] tw-text-gray-2">
                  Use Verse instead of juggling 5+ DME vendors
                </div>
              </div>
              <div className="tw-my-[23px]">
                <img
                  src="/homepage/checkmark_image.png"
                  className="tw-mr-[8px] tw-inline-block tw-h-[18px] tw-align-middle"
                />
                <div className="tw-inline-block tw-align-middle tw-text-[16px] tw-text-gray-2">
                  A flexible program to best fit your practice
                </div>
              </div>
            </div>
            <Link
              to="/contact_us"
              className="tw-ease tw-rounded-md tw-bg-blue-2 tw-px-[13px] tw-py-[10px] tw-text-white tw-transition-all hover:tw-bg-blue-0 hover:tw-text-white hover:tw-no-underline focus:tw-text-white focus:tw-no-underline"
            >
              Book a demo
            </Link>
          </div>
          <div className="tw-w-1/2 tw-p-[5px] 840:tw-hidden">
            <img src="/software.png" width={"100%"} height={"auto"} />
          </div>
        </div>
      </div>
      <div className="tw-bg-gray-light-3 tw-p-[13px]">
        <div className="tw-mx-auto tw-max-w-[1040px] tw-px-[20px] tw-py-[50px]">
          <h5 className="tw-font-dm-sans tw-uppercase tw-tracking-[0.08em] tw-text-blue-1">
            What Our Providers Say
          </h5>
          <div className="tw-p-[40px]">
            <h1 className="tw-t-0 tw-l-0 tw-absolute tw-z-0 tw-translate-x-[-80px] tw-translate-y-[-120px] tw-p-[10px] tw-text-[512px] tw-text-gray-light-4">
              &#8220;
            </h1>
            <h2 className="tw-relative tw-text-[28px]">
              We've had fantastic feedback on your service from both our staff
              as well as our patients. Being able to see everything in one place
              with the software is gamechanging.
            </h2>
            <div>
              <span className="tw-text-blue-dark-1">- Nurse Manager</span>
              <br />
              <span className="tw-ml-[10px] tw-text-gray-3">
                Outpatient Care Center in Georgia
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="tw-relative tw-mx-auto tw-flex tw-max-w-[1040px] tw-flex-row tw-flex-wrap tw-p-[40px]">
        <div className="tw-w-1/2 840:tw-hidden">
          <img src="/homepage/img5.png" className="tw-h-[400px]" />
        </div>
        <div className="tw-w-1/2 tw-p-[40px] 840:tw-w-full 840:tw-p-[30px]">
          <h1>Interested in learning more?</h1>
          <Link
            to="/contact_us"
            className="tw-ease tw-m-auto tw-mt-[20px] tw-rounded-full tw-bg-blue-2 tw-p-[13px] tw-px-[15px] tw-text-white tw-shadow-sm tw-transition-all hover:tw-bg-blue-0 hover:tw-text-white hover:tw-no-underline focus:tw-text-white focus:tw-no-underline"
          >
            Contact us <i className="fa fa-arrow-right" />
          </Link>
        </div>
      </div>
    </div>
  );
}
